import Heading from '@components/web/heading/Heading.tsx';
import { dienstandData } from '@/pages/home/components/diensten/dienstan.data.tsx';
import SubHeading from '@components/web/heading/SubHeading.tsx';
import DienstenTestimonial from '@/pages/home/components/diensten/DienstenTestimonial.tsx';

const Diensten = () => {
  return (
    <div id="diensten" className="scroller">
      <Heading title="Diensten" />
      <section className="py-10">
        <div className="container">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {dienstandData.map(dienstan => {
              return (
                <div
                  className="text-center"
                  key={dienstan.title.trim().toLowerCase()}
                >
                  <div className="flex items-center justify-center mb-5 h-[90px]">
                    {dienstan.icon}
                  </div>
                  <h4 className="text-[var(--mantine-primary-color-filled)] font-semibold text-lg mb-4">
                    {dienstan.title}
                  </h4>
                  <p className="text-sm leading-[1.7]">{dienstan.info}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      <section className="py-10">
        <div className="container">
          <div className="grid grid-cols-1">
            <SubHeading
              className="text-[24px]"
              title="Wat onze klanten zeggen"
              fullWidth
            />
            <div className="grid grid-cols-1">
              <DienstenTestimonial />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Diensten;
